/** Clearance for portaled pickers above a mobile modal footer. */
export const MODAL_FOOTER_RESERVE = 112;
export const SAFE_AREA_RESERVE = 32;

export const MOBILE_MODAL_POPOVER_COLLISION_PADDING = {
  top: 16,
  right: 16,
  bottom: MODAL_FOOTER_RESERVE + SAFE_AREA_RESERVE,
  left: 16,
} as const;
